import { useMemo } from 'react';
import { useAuth } from '@/contexts/AuthContext';

/**
 * Hook to provide stable auth values and prevent unnecessary re-renders
 */
export const useStableAuth = () => {
  const { 
    user, 
    userRole,
    userRoles,
    profile,
    company, 
    subscriptionExpired, 
    loading,
    isPermissionsLoading,
    signOut,
    activeCompanyId,
  } = useAuth();

  // Serialize unstable references to primitives for stable memoization (BUG-01 fix)
  const rolesKey = userRoles?.join(',') ?? '';
  const profileId = profile?.id;
  const profileName = profile?.full_name;
  const profileComplete = profile?.isComplete;
  const companyId = company?.id;
  const companyName = company?.name;
  const companyActive = company?.active;

  // Quando o usuário fez switch, effectiveCompanyId reflete a empresa ativa.
  // Fallback para company?.id quando activeCompanyId é null (visão consolidada).
  const effectiveCompanyId = (activeCompanyId ?? company?.id) || undefined;

  const stableValues = useMemo(() => ({
    userId: user?.id,
    userRole,
    userRoles,
    profile,
    companyId: effectiveCompanyId,
    companyName: company?.name,
    subscriptionExpired,
    loading,
    isPermissionsLoading,
    hasCompany: !!company,
    isAuthenticated: !!user,
    company,
    activeCompanyId,
  }), [
    user?.id, 
    userRole,
    rolesKey,
    profileId,
    profileName,
    profileComplete,
    effectiveCompanyId,
    companyId, 
    companyName,
    companyActive,
    subscriptionExpired, 
    loading,
    isPermissionsLoading,
    activeCompanyId,
  ]);

  return {
    ...stableValues,
    signOut
  };
};